import { Link } from "react-router-dom";
import { Instagram, Twitter, Youtube, Linkedin } from "lucide-react";
import LogoMark from "@/components/LogoMark";

const socials = [
  { icon: Instagram, label: "Instagram", id: "instagram", href: "https://www.instagram.com/value_clothing_co/" },
  { icon: Twitter, label: "X (Twitter)", id: "twitter", href: null },
  { icon: Youtube, label: "YouTube", id: "youtube", href: null },
  { icon: Linkedin, label: "LinkedIn", id: "linkedin", href: null },
];

const Footer = () => {
  const year = new Date().getFullYear();
  return (
    <footer
      data-testid="site-footer"
      className="border-t border-[#222226] bg-[#0A0A0B]"
    >
      <div className="mx-auto max-w-7xl px-6 py-16 sm:px-8 lg:px-12 lg:py-24">
        <div className="grid gap-12 lg:grid-cols-12">
          <div className="lg:col-span-5">
            <div className="flex items-center gap-3 text-white">
              <LogoMark className="h-10 w-10" />
              <span className="leading-none">
                <span className="block font-serif text-2xl tracking-[0.15em]">
                  ADD VALUE
                </span>
                <span className="mt-1 block font-mono text-[10px] uppercase tracking-[0.4em] text-[#D4AF37]">
                  Holdings LLC
                </span>
              </span>
            </div>
            <p className="mt-8 font-serif text-xl italic text-stone-300">
              “Creating. Building. Adding Value.”
            </p>
            <div className="mt-8 flex gap-3">
              {socials.map((s) => (
                <a
                  key={s.id}
                  href={s.href || "#"}
                  {...(s.href
                    ? { target: "_blank", rel: "noopener noreferrer" }
                    : { onClick: (e) => e.preventDefault() })}
                  data-testid={`footer-social-${s.id}`}
                  aria-label={s.href ? s.label : `${s.label} (coming soon)`}
                  title={s.href ? s.label : "Coming soon"}
                  className="flex h-11 w-11 items-center justify-center border border-[#2a2a2e] text-stone-400 transition-colors duration-300 hover:border-[#D4AF37] hover:text-[#D4AF37]"
                >
                  <s.icon className="h-4 w-4" />
                </a>
              ))}
            </div>
          </div>

          <div className="lg:col-span-2">
            <p className="font-mono text-[10px] uppercase tracking-[0.3em] text-[#D4AF37]">
              Company
            </p>
            <ul className="mt-6 space-y-3 text-sm text-stone-400">
              <li><Link data-testid="footer-link-home" className="transition-colors duration-300 hover:text-white" to="/">Home</Link></li>
              <li><Link data-testid="footer-link-about" className="transition-colors duration-300 hover:text-white" to="/about">About</Link></li>
              <li><Link data-testid="footer-link-contact" className="transition-colors duration-300 hover:text-white" to="/contact">Contact</Link></li>
            </ul>
          </div>

          <div className="lg:col-span-2">
            <p className="font-mono text-[10px] uppercase tracking-[0.3em] text-[#D4AF37]">
              Divisions
            </p>
            <ul className="mt-6 space-y-3 text-sm text-stone-400">
              <li><Link data-testid="footer-link-clothing" className="transition-colors duration-300 hover:text-white" to="/clothing">ADD VALUE Clothing</Link></li>
              <li><Link data-testid="footer-link-business" className="transition-colors duration-300 hover:text-white" to="/business">Business &amp; Ventures</Link></li>
              <li><Link data-testid="footer-link-media" className="transition-colors duration-300 hover:text-white" to="/media">Digital Media</Link></li>
            </ul>
          </div>

          <div className="lg:col-span-3">
            <p className="font-mono text-[10px] uppercase tracking-[0.3em] text-[#D4AF37]">
              Contact
            </p>
            <ul className="mt-6 space-y-3 text-sm text-stone-400">
              <li>
                <a
                  data-testid="footer-email"
                  href="mailto:tionneeduncan@valyouenterprise.com"
                  className="transition-colors duration-300 hover:text-white"
                >
                  tionneeduncan@valyouenterprise.com
                </a>
              </li>
              <li>
                <a
                  data-testid="footer-phone"
                  href="tel:+13073162461"
                  className="transition-colors duration-300 hover:text-white"
                >
                  +1 (307) 316-2461
                </a>
              </li>
            </ul>
          </div>
        </div>

        <div className="mt-16 flex flex-col gap-4 border-t border-[#1c1c1f] pt-8 sm:flex-row sm:items-center sm:justify-between">
          <p data-testid="footer-copyright" className="font-mono text-[10px] uppercase tracking-[0.25em] text-stone-500">
            © {year} ADD VALUE HOLDINGS LLC. All rights reserved.
          </p>
          <div className="flex gap-8 font-mono text-[10px] uppercase tracking-[0.25em] text-stone-500">
            <Link data-testid="footer-link-privacy" to="/privacy" className="transition-colors duration-300 hover:text-[#D4AF37]">
              Privacy Policy
            </Link>
            <Link data-testid="footer-link-terms" to="/terms" className="transition-colors duration-300 hover:text-[#D4AF37]">
              Terms
            </Link>
            <Link data-testid="footer-link-contact-2" to="/contact" className="transition-colors duration-300 hover:text-[#D4AF37]">
              Contact
            </Link>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
